module.exports = __webpack_public_path__ + "static/img/driver-2.bfa5402.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/driver-2.png
// module id = W3NR
// module chunks = 0